/**
 *
 * @component 个人中心/我的方案/项目管理/项目详情/项目成员tab
 *
 **/
import React from 'react';
import './ProjectTurbineTab.scss';
import { Button, Table, Pagination } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import AddTurbineModal from './AddTurbineModal';
const ProjectTurbineTab = props => {
    const [isLoading /* setIsLoading */] = useState(false);
    const [queryForm /* setQueryForm */] = useState({ limit: 9, page: 1 });
    const [modalVisible, setModalVisible] = useState(false);

    const [result /* setResult */] = useState({});
    useEffect(() => {
        props.renderFn(
            <Button type="primary" onClick={addTurbine}>
                {intl.get('projectMember.add')}
            </Button>
        );
    }, []);
    const onPageChange = () => {};
    function addTurbine() {
        setModalVisible(true);
    }

    const columns = [
        {
            title: intl.get('budgetCommonPanel.number'),
            dataIndex: '1',
        },
        {
            title: intl.get('projectSpace.nickName'),
            dataIndex: '2',
        },
        {
            title: intl.get('projectSpace.phone'),
            dataIndex: '3',
        },
        {
            title: intl.get('projectSpace.email'),
            dataIndex: '4',
        },
        {
            title: intl.get('projectSpace.role'),
            dataIndex: '5',
        },
        {
            title: intl.get('projectSpace.lastLogin'),
            dataIndex: '6',
        },
        {
            title: intl.get('base.operation'),
            align: 'right',
            className: 'last-col',
            key: '7',
            render: row => {
                return <DeleteFilled />;
            },
        },
    ];
    return (
        <div className="project-turbine">
            <Table
                className="normal-table"
                loading={isLoading}
                columns={columns}
                dataSource={result.list}
                size="small"
                rowKey={e => {
                    return JSON.stringify(e); //orderCode
                }}
                pagination={false}
                rowClassName="custom-row"
            />
            <Pagination
                size="small"
                current={queryForm.page}
                onChange={onPageChange}
                pageSize={queryForm.limit}
                total={result.total}
                showSizeChanger={false}
                showTotal={total => intl.get('base.total', { total })}
            />

            <AddTurbineModal
                visible={modalVisible}
                setVisible={setModalVisible}
            />
        </div>
    );
};

export default ProjectTurbineTab;
